export default __webpack_public_path__ + "static/media/img-0280-malta-half-face.ba34282b.png";